import '../css/module_search.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import Tab from 'bootstrap/js/dist/tab'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { initCardLazyLoad } from './module_lazyload';

import {configBookCard} from './module_book_card';
import {configArticleCard} from './module_article_card';
import {stopAllCard, getItemPlaying} from './module_player-card';

import {defaultCarouselSetupNew} from './module_swiper';

import './module_common_actions';

import { initNavbar } from './module_header';

import {
    toggleChecked,
    getFormData,
    updateFormElements,
} from './module_aside_forms';
import { attachTryPremiumSubscribe } from './module_common';

let waitId = null

const bookTab = $(".tab-book-attach-clk")
const articleTab = $(".tab-article-attach-clk")
const booksResultSelector = ".search-book-results"
const articlesResultSelector = ".search-article-results"
const booksResultContainer = $(booksResultSelector)
const booksCardContainer = $(booksResultSelector+" .content-results .row")
const articlesResultContainer = $(articlesResultSelector)
const articlesCardContainer = $(articlesResultSelector+" .content-results .row")
const emptySearchClass = "empty-search"
const showmoreBooks = $("#showmorebooks")
const showmoreArticles = $("#showmorearticles")
const nomoreBooks = $(".no-more-books")
const nomoreArticles = $(".no-more-articles")
const showMoreWrapBook = $(".showmore-wrap-book")
const showMoreWrapArticle = $(".showmore-wrap-article")

const skillSearchBtn = $(".skillFilterBtn")
const skillFormCardSelector = ".element-form.skill-el";
const skillInputSelector = ".skill-input";
const skillModal = $("#skillFormModal")
let skillData = getFormData(skillInputSelector);

const progSearchBtn = $(".progFilterBtn")
const progFormCardSelector = ".element-form.prog-el";
const progInputSelector = ".prog-input";
const progModal = $("#progFormModal")
let progData = getFormData(progInputSelector);

const catSearchBtn = $(".catFilterBtn")
const catFormCardSelector = ".element-form.category-el";
const catInputSelector = ".category-input";
const catModal = $("#catFormModal")
let catData = getFormData(catInputSelector);

const orderSearchBtn = $(".orderFilterBtn")
const orderFormCardSelector = ".element-form.order-el";
const orderInputSelector = ".order-input";
const orderModal = $("#orderFormModal")
let orderData = getFormData(orderInputSelector);

let bookFilter = getFilterBookBase()
let articleFilter = []

let lastBookOffset = 0
let lastArticleOffset = 0

const limitValue = 10

const mobileFiltersCarouselSetUp = function(){
    const out = "filters-out"
    const container = "filters-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 'auto', 1, 1)  
}

function attachShowBookNextPage(){
    showmoreBooks.on('click', (el) => {
        if(!booksCardContainer.length) return;
        const elements = booksCardContainer.find(".content-card-horizontal");
        makeBookSearch(elements.length)
    })
}

function attachShowArticleNextPage(){
    showmoreArticles.on('click', (el) => {
        if(!articlesCardContainer.length) return;
        const elements = articlesCardContainer.find(".content-card-horizontal");
        makeArticleSearch(elements.length)
    })
}

function getActiveTab(){
    let active = 'book'
    if (articleTab.hasClass("active")){
        active = 'article'
    }
    return active
}

function initTabClick(){
    $('a[data-bs-toggle="pill"]').on('show.bs.tab', function (e) {
        const el = $(e.target)
        if (el.hasClass("tab-article-attach-clk")){
            skillSearchBtn.css("display", "none")
            manageSearchMoreArticles()
            // check filter is change
            if (JSON.stringify(articleFilter) == JSON.stringify(getFilterBase())) return
            makeArticleSearch(0)
        }else{
            skillSearchBtn.css("display", "flex")
            manageSearchMoreBooks()
            // check filter is change
            if (JSON.stringify(bookFilter) == JSON.stringify(getFilterBookBase())) return
            makeBookSearch(0)
        }
    })
}

//

function initSearchBtn(){
    // skill
    skillSearchBtn.on('click', function(){
        skillModal.modal("show")
    })
    skillModal.on('hide.bs.modal', function(){
        // update cards when modal is closed, back to saved data
        updateFormElements(skillFormCardSelector, skillData);
    })
    $(".skill-reset").on('click', function(){
        updateFormElements(skillFormCardSelector, skillData.map(el => ({...el, val:false})));
    })
    attachSkillFormCardClick()
    attachSkillFormSubmit()

    // progress
    progSearchBtn.on('click', function(){
        progModal.modal("show")
    })
    progModal.on('hide.bs.modal', function(){
        updateFormElements(progFormCardSelector, progData);
    })
    $(".prog-reset").on('click', function(){
        updateFormElements(progFormCardSelector, progData.map(el => ({...el, val:false})));
    })
    attachProgFormCardClick()
    attachProgFormSubmit()

    // category
    catSearchBtn.on('click', function(){
        catModal.modal("show")
    })
    catModal.on('hide.bs.modal', function(){
        updateFormElements(catFormCardSelector, catData);
    })
    $(".category-reset").on('click', function(){
        updateFormElements(catFormCardSelector, catData.map(el => ({...el, val:false})));
    })
    attachCatFormCardClick()
    attachCatFormSubmit()

    // order
    orderSearchBtn.on('click', function(){
        orderModal.modal("show")
    })
    orderModal.on('hide.bs.modal', function(e){
        updateFormElements(orderFormCardSelector, orderData);
    })
    attachOrderFormCardClick()
    attachOrderFormSubmit()
}

function manageSearchMoreBooks(){
    const count = booksCardContainer.find(".content-card-horizontal");
    if(count.length < (lastBookOffset + limitValue)) {
        showmoreBooks.addClass("hide-btn");
        nomoreBooks.removeClass("hide-nomore");
    }else{
        showmoreBooks.removeClass("hide-btn");
        nomoreBooks.addClass("hide-nomore");
    }
}

function manageSearchMoreArticles(){
    const count = articlesCardContainer.find(".content-card-horizontal");
    // for first tab change
    if (count.length == 0) return

    if(count.length < (lastArticleOffset + limitValue)) {
        showmoreArticles.addClass("hide-btn");
        nomoreArticles.removeClass("hide-nomore");
    }else{
        showmoreArticles.removeClass("hide-btn");
        nomoreArticles.addClass("hide-nomore");
    }
}

function updateSearchButton(el, getSelectedFn){
    const count = getSelectedFn().length
    if (count == 0){
        el.html("")
    }else{
        el.html("("+count+")")
    }
}

function formFieldsIsChanged(inputSelector, data){
    const formData = getFormData(inputSelector)
    return !formData.every(formEl => {
        const elementStored = data.filter(el => el.id == formEl.id)[0]
        return elementStored.val == formEl.val
    });
}

function makeNewSearch(afterSearchFn){
    if (getActiveTab() == 'book'){
        makeBookSearch(0)
            .then( data => {
                afterSearchFn()
            })
    }else{
        makeArticleSearch(0)
            .then( data => {
                afterSearchFn()
            })
    }
}

//

function attachSkillFormSubmit(){
    $(".skill-form").submit(function( event ) {
        event.preventDefault();
        if (!formFieldsIsChanged(skillInputSelector, skillData)){
            skillModal.modal('hide')
            return
        }
        skillData = getFormData(skillInputSelector)

        skillModal.modal('hide')

        function updateFn(){
            updateSearchButton($(".skill-f-num"), getSelectedSkill)
        }
        makeNewSearch(updateFn)
      });
}

function attachSkillFormCardClick(){
    $(skillFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        if (!target.hasClass('skill-input')){
            event.preventDefault()
            const inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
        }
        el.toggleClass("active")
    })
}

function getSelectedSkill(){
    return skillData
        .filter(el => el.val)
        .map(el => el.id)
}

// 

function attachProgFormSubmit(){
    $(".prog-form").submit(function( event ) {
        event.preventDefault();
        if (!formFieldsIsChanged(progInputSelector, progData)){
            progModal.modal('hide')
            return
        }
        progData = getFormData(progInputSelector)

        progModal.modal('hide')

        function updateFn(){
            updateSearchButton($(".prog-f-num"), getSelectedProg)
        }
        makeNewSearch(updateFn)
    });
}

function attachProgFormCardClick(){
    $(progFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        if (!target.hasClass('prog-input')){
            event.preventDefault()
            const inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
        }
    })
}

function getSelectedProg(){
    return progData
        .filter(el => el.val)
        .map(el => el.id)
}

// 

function attachCatFormSubmit(){
    $(".category-form").submit(function( event ) {
        event.preventDefault();
        if (!formFieldsIsChanged(catInputSelector, catData)){
            catModal.modal('hide')
            return
        }
        catData = getFormData(catInputSelector)

        catModal.modal('hide')

        function updateFn(){
            updateSearchButton($(".cat-f-num"), getSelectedCat)
        }
        makeNewSearch(updateFn)
      });
}

function attachCatFormCardClick(){
    $(catFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        if (!target.hasClass('cat-input')){
            event.preventDefault()
            const inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
        }
        el.toggleClass("active")
    })
}

function getSelectedCat(){
    return catData
        .filter(el => el.val)
        .map(el => el.id)
}

// 

function attachOrderFormSubmit(){
    $(".order-form").submit(function( event ) {
        event.preventDefault();
        if (!formFieldsIsChanged(orderInputSelector, orderData)){
            orderModal.modal('hide')
            return
        }
        orderData = getFormData(orderInputSelector)

        orderModal.modal('hide')

        function updateFn(){
            updateOrderButton(getSelectedOrder())
        }
        makeNewSearch(updateFn)
      });
}

function attachOrderFormCardClick(){
    $(orderFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        let inputEl = undefined
        if (!target.hasClass('order-input')){
            event.preventDefault()
            inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
            
        }else{
            inputEl = $(target)[0]
        }
        const tempOrderData = getFormData(orderInputSelector);
        tempOrderData.map(el => {
            el.val = el.id == inputEl.id
            return el
        })
        updateFormElements(orderFormCardSelector, tempOrderData);
        el.toggleClass("active")
        
    })
}

function getSelectedOrder(){
    return orderData.filter(el => el.val)[0].id
}

function getSelectedOrderText(){
    const inputEl = orderData.filter(el => el.val)[0]
    const id =  inputEl.id
    const el = $("#"+id)
    return el.data("btntext")
}

function updateOrderButton(){
    $(".order-f").html(getSelectedOrderText())
}

// 

function makeBookSearch(offset){
    const isNewSearch = !offset || offset == 0
    const itemPlaying = getItemPlaying()
    if (isNewSearch && itemPlaying && itemPlaying.contType == 'book' ){
        stopAllCard()
    }
    return searchContent(searchEndPoint, offset)
        .then(data => {
            if(isNewSearch) {
                if (data.results == 0){
                    booksResultContainer.addClass(emptySearchClass)
                    showMoreWrapBook.addClass(emptySearchClass)
                }else{
                    booksResultContainer.removeClass(emptySearchClass)
                    showMoreWrapBook.removeClass(emptySearchClass)
                    booksCardContainer.html(data['html']);
                }
            } else {
                booksCardContainer.append(data['html']);
            }

            bookFilter = getFilterBookBase()
            lastBookOffset = offset

            if (data.resuts != 0){
                manageSearchMoreBooks()
                initCardLazyLoad()
                configBookCard()
            }

            return data
        })
}

function makeArticleSearch(offset){
    const isNewSearch = !offset
    const itemPlaying = getItemPlaying()
    if (isNewSearch && itemPlaying && itemPlaying.contType == 'article' ){
        stopAllCard()
    }
    return searchContent(searchArticleEndPoint, offset)
        .then(data => {
            if(isNewSearch) {
                if (data.results == 0){
                    articlesResultContainer.addClass(emptySearchClass)
                    showMoreWrapArticle.addClass(emptySearchClass)
                }else{
                    articlesResultContainer.removeClass(emptySearchClass)
                    showMoreWrapArticle.removeClass(emptySearchClass)
                    articlesCardContainer.html(data['html']);
                }
            } else {
                articlesCardContainer.append(data['html']);
            }

            articleFilter = getFilterBase()
            lastArticleOffset = offset

            if (data.results != 0){
                manageSearchMoreArticles()
                initCardLazyLoad()
                configArticleCard()
            }
            
            return data
        })
}

function setUISearchString(txt){
    $(".search-string").val(txt)
}

function getFilterBase(){
    return {
        cat: getSelectedCat(),
        readStatus: getSelectedProg(),
        text: searchText,
        ord: getSelectedOrder(),
    }
}

function getFilterBookBase(){
    const base = getFilterBase()
    return {
        skill: getSelectedSkill(),
        ...base,
    }
}

function getFilter(offset){
    const base = getFilterBookBase()
    return {
        limit: limitValue,
        offset: offset,
        ...base,
    }
}

function showWaitBlock(isNewSearch){
    // show spinner only after spinnerTimeout ms
    const spinnerTimeout = 300

    const waitClass = isNewSearch ? "wait-search-new" : "wait-search-showmore"
    waitId = setTimeout(()=>{
        $("#books").addClass(waitClass)
        $("#articles").addClass(waitClass)
    }, spinnerTimeout)
}

function hideWaitBlock(isNewSearch){
    clearTimeout(waitId)

    const waitClass = isNewSearch ? "wait-search-new" : "wait-search-showmore"
    $("#books").removeClass(waitClass)
    $("#articles").removeClass(waitClass)
}

function searchContent(url, offset){
    const newSearch = !offset || offset == 0
    return new Promise((resolve, reject) => {
        showWaitBlock(newSearch)
        $.ajax({
            method: 'POST',
            url: url,
            data: getFilter(offset),
            dataType: 'json',
            success: function(data){
                hideWaitBlock(newSearch)
                resolve(data)
            },
            error: function(err){
                hideWaitBlock(newSearch)
                console.log("ERROR: ", err)
                reject(err)
            }
        })
    })
}

$(function() {
    initFirebaseApp()
    doLast()
    initCardLazyLoad()

    attachTryPremiumSubscribe()

    mobileFiltersCarouselSetUp()

    initTabClick()
    initSearchBtn()

    initNavbar()
    configBookCard()
    configArticleCard()

    attachShowBookNextPage()
    attachShowArticleNextPage()
});